var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9946 7.87987C13.1472 7.74909 13.2235 7.6837 13.2514 7.60589C13.2759 7.5376 13.2759 7.46289 13.2514 7.3946C13.2235 7.31678 13.1472 7.25139 12.9946 7.12062L7.7004 2.58273C7.43775 2.3576 7.30643 2.24504 7.19525 2.24228C7.09862 2.23989 7.00633 2.28234 6.94526 2.35726C6.875 2.44347 6.875 2.61643 6.875 2.96235V5.64689C5.54083 5.8803 4.31975 6.55634 3.41232 7.57141C2.42302 8.67806 1.87577 10.1102 1.875 11.5946V11.9771C2.53084 11.187 3.34969 10.5481 4.27547 10.1039C5.09169 9.71239 5.97401 9.48044 6.875 9.41932V12.0381C6.875 12.3841 6.875 12.557 6.94526 12.6432C7.00633 12.7182 7.09862 12.7606 7.19525 12.7582C7.30643 12.7554 7.43775 12.6429 7.7004 12.4178L12.9946 7.87987Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare06);
export default __webpack_public_path__ + "static/media/share-06.5e46e9429f0b68c9322faeffa9d00de5.svg";
export { ForwardRef as ReactComponent };